import { render, staticRenderFns } from "./DocTop.vue?vue&type=template&id=7da20ce5&"
import script from "./DocTop.vue?vue&type=script&lang=js&"
export * from "./DocTop.vue?vue&type=script&lang=js&"
import style0 from "./DocTop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports